import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "../analytics/gtag";

/**
 * Records GA4 page views on React Router navigations (initial load is handled by gtag in index.html).
 */
export function GoogleAnalytics(): null {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const path = `${pathname}${search}`;
    trackPageView(path, document.title);
  }, [pathname, search]);

  return null;
}
